export enum EnumAuthenticateState{ 
    UserInconnu = 0,
    MDPIncorrect, 
    CpteBloque, 
    CnxOK, 
    ChgMDP, 
    CheckInfos, 
    CpteDesact, 
    TwoFactorRequired
}